import { useMemo } from 'react';
import { useSafeIntl } from 'bluesquare-components';
import { DropdownOptions } from '../../../../../../../../hat/assets/js/apps/Iaso/types/utils';
import { defaultVaccineOptions } from '../../SupplyChain/constants';
import MESSAGES from '../messages';

const statuses: string[] = ['draft', 'commented', 'final'];

export const useStatusOptions = (): DropdownOptions<string>[] => {
    const { formatMessage } = useSafeIntl();
    return useMemo(() => {
        return statuses.map(status => {
            return {
                value: status,
                label: MESSAGES[status.toLowerCase()]
                    ? formatMessage(MESSAGES[status.toLowerCase()])
                    : status,
            };
        });
    }, [formatMessage]);
};

export const vaccineOptions: DropdownOptions<string>[] =
    defaultVaccineOptions.filter(option => option.value !== 'mOPV2');
